import { route } from 'react-router-typesafe-routes/dom';
import { yup } from 'react-router-typesafe-routes/yup';
import * as Yup from 'yup';

export const CardMachineSignUpRoutes = {
	CARD_MACHINE_SIGN_UP: route(
		'cmsignup',
		{
			searchParams: {
				token: yup(Yup.string().uuid()),
				castles: yup(Yup.string().optional().oneOf(['true'])),
			},
		},
		{
			NOT_FOUND: route('*', {}),
			TEST: route('test', {}),
		}
	),
};
